'use strict';

;( () => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'facetwp', ( type = 'posts' ) =>  ({

			categories: false,
			tags      : false,
			topics    : false,
			active    : false,

			init() {

				document.addEventListener( 'facetwp-loaded', () => {
					let isFiltered = false;

					for ( const key in FWP.facets ) {

						if ( 0 < FWP.facets[ key ].length ) {
							isFiltered = true;
							break;
						}
					}

					// Check for active keyword search.
					if ( FWP.q && FWP.q.s && 0 < FWP.q.s.length ) isFiltered = true;

					// Show or hide the element based on filter state.
					this.$refs.showIfFiltered.style.display = isFiltered ? 'flex' : 'none';

					const results = document.querySelectorAll( '.facetwp-template > *' );
					const message = document.getElementById( 'facetwp-no-results' );

					if ( 0 === results.length ) {
						message.classList.remove( 'hidden' );
					} else {
						message.classList.add( 'hidden' );
					}
				});
			},
		}) );
	});
})();
